import {
    ADD_PACKAGE_TO_BASKET,
    ADD_PACKAGE_TO_BASKET_ERROR,
    ADD_PACKAGE_TO_BASKET_SUCCESS,
} from "core-web/state/models/Basket/constants";

import AddPackageToBasket from "core-web/libs/GrebbCommerceAPI/Basket/AddPackageToBasket";
import { BasketEvents } from "core-web/libs/Events/constants";
import Events from "core-web/libs/Events";
import { acquireMutex } from "core-web/state";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import createBasket from "core-web/state/models/Basket/dispatches/createBasket";
import getBasket from "core-web/state/models/Basket/dispatches/getBasket";
import getBasketId from "core-web/state/models/Basket/utils/getBasketId";

import setBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setBasketItemsAmountCookie";
import setUniqueBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setUniqueBasketItemsAmountCookie";
import store from "core-web/state/store";
import tracking from "core-web/components/Tracking";
import updateBasketPackageItem from "core-web/state/models/Basket/dispatches/updateBasketPackageItem";

export const addPackageToBasket = (packageItems, mainProduct) => async (dispatch, getState) => {
    const basketId = await getBasketId();
    let basket = getState().basket;
    const eventId = tracking.getUniqueId();
    const newBasketItem = {};

    if (!basketId) {
        await createBasket();
    } else if (!basket.isFetched) {
        basket = await getBasket();
    }

    const mutexLock = await acquireMutex("basket.getBasket");
    dispatch({ type: ADD_PACKAGE_TO_BASKET });

    try {
        if (packageItems.length > 0) {
            if (packageItems[0].isQuantityPackage) {
                basket.items?.length &&
                    basket.items.forEach((item) => {
                        if (item.part_no === packageItems[0].part_no) {
                            newBasketItem.id = item.id;
                            newBasketItem["line_no"] = item.line_no;
                            newBasketItem.newQuantity =
                                parseInt(packageItems[0].quantity, 10) + parseInt(item.quantity, 10);
                        }
                    });
            }
        }

        if (newBasketItem.id) {
            mutexLock();
            return updateBasketPackageItem(newBasketItem, newBasketItem.newQuantity, "add");
        }

        const response = await AddPackageToBasket(basketId, packageItems, eventId);

        const basketItemsTree = buildCartProductTree(response.data.items);
        const basketItemsCount = basketItemsTree.reduce((total, item) => total + (item.quantity || 0), 0);
        setBasketItemsAmountCookie(basketItemsCount);
        setUniqueBasketItemsAmountCookie(basketItemsTree.length);

        dispatch({
            type: ADD_PACKAGE_TO_BASKET_SUCCESS,
            items: basketItemsTree,
            summary: response.data.format.summary,
            promotions: response.data.applied_promotions,
        });

        Events.trigger(BasketEvents.UPDATED);
        Events.trigger(BasketEvents.PRODUCT_ADDED, { basketId, item: mainProduct, eventId });

        mutexLock();

        return response;
    } catch (e) {
        dispatch({ type: ADD_PACKAGE_TO_BASKET_ERROR });

        mutexLock();

        throw e;
    }
};

export default (packageItems, mainProduct) => store.dispatch(addPackageToBasket(packageItems, mainProduct));
